import { getWalletOperations } from "@/Api/walletOperations";
import { CreateLoaderTable } from "@/components/Loaders";
import { Main } from "@/components/Main";
import { useEffect, useState, useCallback } from "react";
import { TableData } from "@/App/WalletOperations/Table";
import { WalletOperationsResponse, WalletOperationsFilters } from "@/App/WalletOperations/shared/types";
import { WalletOperationsFiltersComponent } from "@/App/WalletOperations/Filters";
import { Wallet } from "lucide-react";
import { PageHeader } from "@/components/PageHeader";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { BalanceAdjustments } from "@/App/WalletOperations/Adjustments";

export const PageList = () => {
  const [listData, setListData] = useState<WalletOperationsResponse>({
    data: [],
    current_page: 1,
    last_page: 1,
    per_page: 15,
    total: 0,
  });
  const [state, setState] = useState("loading");
  const [currentFilters, setCurrentFilters] = useState<WalletOperationsFilters>({});

  const fetchData = useCallback(async (filters: WalletOperationsFilters = {}) => {
    setState("loading");
    try {
      const { data } = await getWalletOperations(filters);
      if (data?.response) {
        setListData(data.response);
      }
    } catch (error) {
      console.error("Error fetching operations:", error);
    } finally {
      setState("production");
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleFilter = (filters: WalletOperationsFilters) => {
    setCurrentFilters(filters);
    fetchData({ ...filters, page: 1 });
  };

  const pageActions = {
    next: async () => {
      if (listData?.current_page < listData?.last_page) {
        fetchData({ ...currentFilters, page: listData.current_page + 1 });
      }
    },
    previous: async () => {
      if (listData?.current_page > 1) {
        fetchData({ ...currentFilters, page: listData.current_page - 1 });
      }
    },
    lastPage: async () => {
      if (listData?.current_page !== listData?.last_page) {
        fetchData({ ...currentFilters, page: listData.last_page });
      }
    },
  };

  return (
    <Main>
      <PageHeader
        icon={Wallet}
        title="Gerenciamento Carteira"
        description="Operações da carteira e ajustes de saldo com aprovação"
      />
      <Tabs defaultValue="operacoes">
        <TabsList className="mb-3">
          <TabsTrigger value="operacoes">Operações</TabsTrigger>
          <TabsTrigger value="ajustes">Ajustes de Saldo</TabsTrigger>
        </TabsList>
        <TabsContent value="operacoes">
        <div className="flex flex-col gap-3">
          <WalletOperationsFiltersComponent
            onFilter={handleFilter}
            loading={state === "loading"}
          />
          {state === "loading" ? (
            <CreateLoaderTable cols={8} lines={6} />
          ) : (
            <TableData dataApi={listData} pageActions={pageActions} />
          )}
        </div>
        </TabsContent>
        <TabsContent value="ajustes">
          <BalanceAdjustments />
        </TabsContent>
      </Tabs>
    </Main>
  );
};
